export default __webpack_public_path__ + "static/media/WhileLoopsImg.dfa2e7a0.jpg";